import { Button, Col, Row, Select, Form, DatePicker, Switch, Table, Tooltip, Tag, Divider } from "antd";
import { useTranslation } from "react-i18next";
import { KeyValue } from "../../../models/AccountAsignationData";
import { CiOutlined, CreditCardOutlined, BankOutlined, WalletOutlined, DollarOutlined, CheckOutlined, DeleteOutlined, EditOutlined, ExclamationCircleFilled, StarTwoTone, WarningFilled } from "@ant-design/icons";
import './PaymentsMethodElement.scss';
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAppLanguage } from "../../../RoutesApp";
import { GetConfigurationAccounts } from "../../../api/repositoryEP";
import debounce from "lodash/debounce";
import { getAccountTypeIcon } from '../../../utils/icons';
import { EditPaymentConfigurationData, PaymentConfigurationData, PaymentMethodData } from "../../../models/PaymentMethodData";
import { GenericKeyValuePair } from "../../../models/CustomField";
import { GenericModal } from "../../common/Modal/GenericModal";
import { set } from "lodash";
import HTMLReactParser from "html-react-parser";



interface PaymentMethodElementProps {
    configuration: PaymentConfigurationData;
    setEditDrawerVisible: (isVisible: boolean) => void;
    setSelectedConfiguration: (c: PaymentConfigurationData | null) => void; // Nueva prop

    markets: KeyValue[];
    paymentsMethods: PaymentMethodData[];


    save: (data: EditPaymentConfigurationData) => void;
    edit: (data: EditPaymentConfigurationData) => void;
    delete: (id: string) => void;


}

const PaymentMethodElement = (props: PaymentMethodElementProps): JSX.Element => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toTitleCase = (str: string) => str ? str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) : str;

    const getPaymentMethodIcon = (refCode: string) => {
        const code = (refCode ?? '').toLowerCase();
        if (code.includes('tpv') || code.includes('card') || code.includes('visa') || code.includes('master')) return <CreditCardOutlined style={{ fontSize: 20 }} />;
        if (code.includes('transfer') || code.includes('bank') || code.includes('sepa')) return <BankOutlined style={{ fontSize: 20 }} />;
        if (code.includes('cash') || code.includes('efectivo') || code.includes('wallet')) return <WalletOutlined style={{ fontSize: 20 }} />;
        return <DollarOutlined style={{ fontSize: 20 }} />;
    };
    const [form] = Form.useForm();

    const [deleting, setIsDeleting] = useState<boolean>(false);
    const [saving, setIsSaving] = useState<boolean>(false);
    const [isChangingStatus, setIsChangingStatus] = useState<boolean>(false);

    const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);


    const [loading, setLoading] = useState<boolean>(false);
    const [totalMatches, setTotalMatches] = useState<number>(0); // Total de coincidencias en la búsequeda
    const [accountSearchValue, setAccountSearchValue] = useState<string>('');
    const [options, setOptions] = useState(
        props.configuration?.accountsSelected?.map((account) => ({
            label: account.name, // Mostrar el 'value' como etiqueta
            value: account.id,  // Usar el 'key' como valor interno
            country: account.country, // O la propiedad específica que tengas para el país
            accountType: account.accountType
        }))
    );


    const [selectedPaymentIds, setSelectedPaymentIds] = useState<string[]>(props.configuration.paymentsMethodSelected || []);
    const [isDirty, setIsDirty] = useState<boolean>(false);

    // para deshabilitar que se elija dos tipos de tpv distintos: si hay un tpv seleccionado, el resto de tpv se deshabilitan
    const isTpv = (pm: PaymentMethodData) => pm.refCode?.toLowerCase().includes("tpv") ?? false;
    const hasTpvSelected = props.paymentsMethods.some(pm => isTpv(pm) && selectedPaymentIds.includes(pm.id));
    const disabledPaymentIds = hasTpvSelected
        ? props.paymentsMethods.filter(pm => isTpv(pm) && !selectedPaymentIds.includes(pm.id)).map(pm => pm.id)
        : [];

    const handlePaymentMethodChange = (selectedValues: string[]) => {


        // Consigue la lista completa de objetos PaymentMethod
        const selectedMethods = props.paymentsMethods.filter(pm =>
            selectedValues.includes(pm.id)
        );

        const isPCISelected = selectedMethods.some(pm =>
            pm.refCode?.toLowerCase().includes("pci")
        );

        if (isPCISelected) {
            const pciPm = selectedMethods.find(pm =>
                pm.refCode?.toLowerCase().includes("pci")
            );
            console.log("PCI detectado:", pciPm?.id);
            //  guardamos el ID correctamente
            setPendingPciPmId(pciPm!.id);
            setPciModalVisible(true);
        }

        // Actualizar el formulario
        form.setFieldValue("paymentsMethod", selectedValues);
        setSelectedPaymentIds(selectedValues);
        setIsDirty(true);
    };





    const [selectedAccountValues, setSelectedAccountValues] = useState(
        props.configuration.accountsSelected?.map((account) => ({
            id: account.id,
            name: account.name,
            accountType: account.accountType,
            country: account.country,
            address: account.address ?? '',
        }))
    );

    const [selectedCountries, setSelectedCountries] = useState<string[]>(props.configuration.marketsSelected || []); // Cantidad de opciones seleccionadas






    const onDeleteConfiguration = async (id: string) => {
        setIsDeleting(true);
        try {
            await props.delete(id); // Llama a la función de eliminación

        } finally {
            setIsDeleting(false);
        }
    };

    const handleSave = async (values: any) => {
        setIsSaving(true)

        var accountsData = (values.accounts ?? []).map((accountId: string) => {
            var accountType = selectedAccountValues.find((accountValue) => accountValue.id === accountId)?.accountType;
            var data: GenericKeyValuePair = {
                key: accountId,
                value: accountType
            }

            return data;
        })


        const updatedAccount: EditPaymentConfigurationData = {
            id: props.configuration.id,
            name: null,
            isActive: null,
            isDefault: null,
            marketsSelected: values.markets ?? null,
            accountsSelected: accountsData.length > 0 ? accountsData : null,
            paymentsMethodSelected: values.paymentsMethod,
        };

        try {
            await props.save(updatedAccount);
            setIsDirty(false);
        } finally {
            // Desactiva el estado de carga para este ID
            setIsSaving(false)
        }
    };


    /////////////////////////////////// SWITCH ///////////////////////////////////
    const [currentSwitchValue, setCurrentSwitchValue] = useState<boolean>(props.configuration.isActive);
    const handleSwitchClick = async (currentChecked: boolean) => {

        const updatedAccount: EditPaymentConfigurationData = {
            id: props.configuration.id,
            name: null,
            isActive: currentChecked,
            isDefault: null,
            marketsSelected: null, // Ya contiene los keys seleccionados
            accountsSelected: null, // Ya contiene los keys seleccionados
            paymentsMethodSelected: null, // Directamente el key seleccionado
        };


        try {
            setIsChangingStatus(true)
            const r = await props.edit(updatedAccount);

            setCurrentSwitchValue(currentChecked);

        } finally {
            // Desactiva el estado de carga para este ID
            setIsChangingStatus(false)
        }
    };

    /////////////////////////////////// SWITCH ///////////////////////////////////






    const handleChangeSelect = (values: string[]) => {


        // Obtener las opciones seleccionadas basadas en los nuevos valores
        const updatedSelected = options?.filter(opt => values.includes(opt.value));

        // Combinar las cuentas previamente seleccionadas con las nuevas, sin duplicados
        const combinedSelected = [
            ...(selectedAccountValues || []),
            ...(updatedSelected ?? []).map(opt => ({
                id: opt.value,
                name: opt.label,
                country: opt.country,
                accountType: opt.accountType,
                address: (opt as any).address ?? '',
            })),
        ].filter((value, index, self) =>
            index === self.findIndex(v => v.id === value.id) // Eliminar duplicados por ID
        );

        // Actualizar el estado local de selectedAccountValues
        setSelectedAccountValues(combinedSelected);

        // Actualizar el campo del formulario con los IDs seleccionados
        form.setFieldValue(
            'accounts',
            combinedSelected.map(account => account.id)
        );
    };

    const handleChangeDeselect = (value: string) => {
        // Filtrar la cuenta eliminada del estado
        const updatedSelected = selectedAccountValues?.filter(account => account.id !== value);
        setSelectedAccountValues(updatedSelected);

        // Actualizar el formulario con los IDs restantes
        form.setFieldValue(
            'accounts',
            updatedSelected?.map(account => account.id)
        );

        setOptions(options?.filter(option => option.value !== value));
    };



    const handleSearch = useCallback(
        debounce(async (name) => {

            if (name) {
                setLoading(true);
                try {
                    const response = await GetConfigurationAccounts(selectedCountries, name);
                    if (response?.type === 1) {
                        // Formatear las opciones y excluir seleccionados
                        const formattedOptions = response.data.accounts
                            .map((account: any) => {
                                const isLinked = selectedAccountValues?.some(a => a.id === account.id) ?? false;
                                return {
                                    label: (
                                        <div className="account-info">
                                            <label>{account.name} {isLinked && <Tag color="orange" style={{ marginLeft: 4 }}>{t("pages.payments-configuration.already-linked")}</Tag>}</label>
                                            <small>{account.actualContractName}</small>
                                            <small>{account.address} ({account.country})</small>
                                        </div>
                                    ),
                                    value: account.id,
                                    name: account.name,
                                    address: account.address,
                                    accountType: account.accountType,
                                    actualContractName: account.actualContractName,
                                    country: account.country,
                                    disabled: isLinked,
                                };
                            });

                        // Actualizar las opciones sin acumular duplicados
                        setOptions(formattedOptions);
                        setTotalMatches(formattedOptions.length);
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                setOptions([]); // Limpia si no hay búsqueda
                setTotalMatches(0);
            }
        }, 300),
        [selectedAccountValues, selectedCountries]
    );





    useEffect(() => {
        // Sincronizar el campo del formulario con los IDs de las cuentas seleccionadas
        form.setFieldValue(
            'accounts',
            selectedAccountValues?.map(account => account.id)
        );
    }, [selectedAccountValues, form]);



    useEffect(() => {
        return () => handleSearch.cancel();
    }, [handleSearch]);

    const handleAddAccount = (value: string) => {
        const option = options?.find(opt => opt.value === value);
        if (!option) return;

        const newAccount = {
            id: option.value,
            name: (option as any).name ?? option.value,
            country: (option as any).country ?? '',
            accountType: (option as any).accountType ?? '',
            address: (option as any).address ?? '',
        };

        const combined = [
            ...(selectedAccountValues || []),
            newAccount,
        ].filter((v, i, self) => self.findIndex(x => x.id === v.id) === i);

        setSelectedAccountValues(combined);
        form.setFieldValue('accounts', combined.map(a => a.id));
        setAccountSearchValue('');
        setOptions([]);
        setTotalMatches(0);
        setIsDirty(true);
    };

    const handleRemoveAccount = (id: string) => {
        const updated = (selectedAccountValues || []).filter(a => a.id !== id);
        setSelectedAccountValues(updated);
        form.setFieldValue('accounts', updated.map(a => a.id));
        setIsDirty(true);
    };





    ////////////////////////////////////////////////// COUNTRIES ////////////////////////////////////////////

    const handleSelectCountry = (value: string) => {
        // Agregar el país a la lista de países seleccionados
        setSelectedCountries((prevSelected) => [...prevSelected, value]);

        // Filtrar las cuentas seleccionadas que correspondan al país actual o a cualquier país en selectedCountries
        setSelectedAccountValues((prevSelected) =>
            (prevSelected || []).filter(
                (account) =>
                    account.country === value || selectedCountries.includes(account.country)
            )
        );
        setIsDirty(true);
    };

    const handleDeselectCountry = (value: string) => {
        // 1. Eliminar el país de la lista de países seleccionados
        setSelectedCountries((prevSelected) =>
            prevSelected.filter((country) => country !== value)
        );

        // 2. Actualizar las cuentas seleccionadas para eliminar las asociadas al país deseleccionado
        setSelectedAccountValues((prevSelected) =>
            (prevSelected || []).filter((account) =>
                selectedCountries.filter((country) => country !== value).includes(account.country)
            )
        );
        setIsDirty(true);
    };
    //////////////////////////////// PCI  /////////////////////////////////////////////
    const [pciModalVisible, setPciModalVisible] = useState<boolean>(false);
    const [pendingPciPmId, setPendingPciPmId] = useState<string | null>(null);

    function HtmlReactParser(arg0: any): import("react").ReactNode {
        throw new Error("Function not implemented.");
    }

    ///////////////////////////////////////////////

    const currenciesBlock = (() => {
        const allCurrencies = Array.from(new Set(
            props.paymentsMethods
                .filter(pm => selectedPaymentIds.includes(pm.id) && (pm.currenciesSupported?.length ?? 0) > 0)
                .flatMap(pm => pm.currenciesSupported)
        ));
        if (allCurrencies.length === 0) return null;
        return (
            <div className="currencies-supported-section">
                <span className="currencies-supported-label">{t('pages.payments-configuration.currencies-supported')}</span>
                <div className="currencies-tags">
                    {allCurrencies.map(c => (
                        <span key={c} className="currency-tag">{c}</span>
                    ))}
                </div>
            </div>
        );
    })();

    return (
        <div className="payments-configuration-element">
            <GenericModal
                visible={pciModalVisible}
                onCancel={() => { // tenemos que deseleccionar el pci 
                    form.setFieldValue(
                        "paymentsMethod",
                        form.getFieldValue("paymentsMethod").filter((id: string) => id !== pendingPciPmId)
                    );
                    setPciModalVisible(false);
                }}
                onOk={() => {
                    setPendingPciPmId(null);
                    setPciModalVisible(false);
                }}
                title={t("modal.warning")}
                content={
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            gap: "20px",
                        }}
                    >
                        <ExclamationCircleFilled
                            style={{ color: "#ff4d4f", fontSize: 48 }}
                        />
                        <div className="pci-warning-text">
                            {HTMLReactParser(t("modal.pci-warning"))}
                        </div>
                    </div>
                }
                requiredCheckboxText={t('modal.risk-understood') || ''}
                isLoading={false}

            />
            <Row >
                <Col xs={24} md={24} className={`configuration-container${props.configuration.isDefault ? " is-default" : ""}`} >
                    <Form
                        form={form}
                        layout="vertical"
                        initialValues={{
                            isActive: props.configuration.isActive,
                            markets: props.configuration.marketsSelected,
                            accounts: props.configuration.accountsSelected?.map((account) => account.id), // Preselección de valores
                            paymentsMethod: props.configuration.paymentsMethodSelected,
                        }}
                        onFinish={(values) => {
                            handleSave(values);
                        }} // Manejar guardar
                    >

                        {/* Row 1: Cabecera — nombre + lápiz / switch */}
                        <div className="title-container">
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <h3 style={{ margin: 0 }}>{props.configuration.name}</h3>
                                <EditOutlined
                                    className="edit-icon-style"
                                    onClick={() => {
                                        props.setSelectedConfiguration(props.configuration);
                                        props.setEditDrawerVisible(true);
                                    }}
                                />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Form.Item name="isActive" className="switch-container" style={{ marginBottom: 0 }}>
                                    {(() => {
                                        const hasPaymentMethods = (props.configuration.paymentsMethodSelected?.length ?? 0) > 0;
                                        const hasCountriesOrAccounts = props.configuration.isDefault ||
                                            ((props.configuration.marketsSelected?.length ?? 0) > 0 ||
                                             (props.configuration.accountsSelected?.length ?? 0) > 0);
                                        const canActivate = hasPaymentMethods && hasCountriesOrAccounts;
                                        const switchDisabled = isChangingStatus || (!currentSwitchValue && !canActivate);
                                        const tooltipTitle = !currentSwitchValue && !canActivate
                                            ? !hasPaymentMethods
                                                ? t("pages.payments-configuration.payment-methods-required")
                                                : t("pages.payments-configuration.no-accounts-or-countries")
                                            : undefined;
                                        return (
                                            <Tooltip title={tooltipTitle}>
                                                <Switch
                                                    className="app-switch"
                                                    checked={currentSwitchValue}
                                                    disabled={switchDisabled}
                                                    onClick={(value) => handleSwitchClick(value)}
                                                />
                                            </Tooltip>
                                        );
                                    })()}
                                </Form.Item>
                            </div>
                        </div>

                        <Divider style={{ margin: '12px 0' }} />

                        {/* Row 2: Contenido */}
                        <Row gutter={[10, 0]}>
                            {props.configuration.isDefault ? (
                                <Col xs={24}>
                                    <Form.Item name="paymentsMethod" rules={[{ required: true, message: t("pages.payments-configuration.payment-methods-required") || "" }]} style={{ display: 'none' }}>
                                        <Select mode="multiple" />
                                    </Form.Item>
                                    <div className="payment-method-pills-label">{t("pages.payments-configuration.payments-method")}</div>
                                    <div className="payment-method-pills">
                                        {props.paymentsMethods.map((pm: PaymentMethodData) => {
                                            const isSelected = selectedPaymentIds.includes(pm.id);
                                            const isDisabled = disabledPaymentIds.includes(pm.id);
                                            return (
                                                <div
                                                    key={pm.id}
                                                    className={`payment-pill${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}`}
                                                    onClick={() => {
                                                        if (isDisabled) return;
                                                        const next = isSelected
                                                            ? selectedPaymentIds.filter(id => id !== pm.id)
                                                            : [...selectedPaymentIds, pm.id];
                                                        handlePaymentMethodChange(next);
                                                    }}
                                                >
                                                    {getPaymentMethodIcon(pm.refCode)}
                                                    <span className="pill-name">{pm.name}</span>
                                                    {isSelected && <CheckOutlined className="pill-check" />}
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {currenciesBlock}
                                    <small className="default-config-help">{t("pages.payments-configuration.default-help")}</small>
                                </Col>
                            ) : (
                                <>
                                    {/* Columna izquierda: Países + Métodos de pago */}
                                    <Col xs={24} md={12}>
                                        <Form.Item name="markets" label={t("pages.account-asignation.market")}>
                                            <Select
                                                className="app-select"
                                                mode="multiple"
                                                value={selectedCountries}
                                                onSelect={handleSelectCountry}
                                                onDeselect={handleDeselectCountry}
                                                options={props.markets.map((market) => ({
                                                    label: market.value,
                                                    value: market.key,
                                                }))}
                                                showSearch
                                                filterOption={(input, option) =>
                                                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                                }
                                            />
                                        </Form.Item>
                                        <Form.Item name="paymentsMethod" rules={[{ required: true, message: t("pages.payments-configuration.payment-methods-required") || "" }]} style={{ display: 'none' }}>
                                            <Select mode="multiple" />
                                        </Form.Item>
                                        <div className="payment-method-pills-label">{t("pages.payments-configuration.payments-method")}</div>
                                        <div className="payment-method-pills">
                                            {props.paymentsMethods.map((pm: PaymentMethodData) => {
                                                const isSelected = selectedPaymentIds.includes(pm.id);
                                                const isDisabled = disabledPaymentIds.includes(pm.id);
                                                return (
                                                    <div
                                                        key={pm.id}
                                                        className={`payment-pill${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}`}
                                                        onClick={() => {
                                                            if (isDisabled) return;
                                                            const next = isSelected
                                                                ? selectedPaymentIds.filter(id => id !== pm.id)
                                                                : [...selectedPaymentIds, pm.id];
                                                            handlePaymentMethodChange(next);
                                                        }}
                                                    >
                                                        {getPaymentMethodIcon(pm.refCode)}
                                                        <span className="pill-name">{pm.name}</span>
                                                        {isSelected && <CheckOutlined className="pill-check" />}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {currenciesBlock}
                                    </Col>

                                    {/* Columna derecha: Cuentas + Tabla */}
                                    <Col xs={24} md={12}>
                                        <Form.Item name="accounts" hidden>
                                            <Select mode="multiple" />
                                        </Form.Item>
                                        <Form.Item label={t("pages.account-asignation.accounts")}>
                                            <Select
                                                className="app-select"
                                                loading={loading}
                                                showSearch
                                                searchValue={accountSearchValue}
                                                value={null}
                                                filterOption={false}
                                                options={options}
                                                notFoundContent={
                                                    accountSearchValue
                                                        ? t("pages.payments-configuration.no-accounts-found")
                                                        : t("pages.payments-configuration.type-to-search-accounts")
                                                }
                                                placeholder={t("pages.payments-configuration.search-account")}
                                                onSearch={(v) => { setAccountSearchValue(v); handleSearch(v); }}
                                                onSelect={(value) => value && handleAddAccount(value)}
                                                dropdownRender={(menu) => (
                                                    <>
                                                        {menu}
                                                        {accountSearchValue && (
                                                            <div style={{ padding: "8px", textAlign: "center", fontStyle: "italic" }}>
                                                                {totalMatches > 0
                                                                    ? `Hay ${totalMatches} coincidencia(s)`
                                                                    : "Sin coincidencias"}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Form.Item>
                                        {(selectedAccountValues?.length ?? 0) > 0 && (
                                            <Form.Item label={t("pages.payments-configuration.assigned-accounts", { count: selectedAccountValues?.length ?? 0 })} colon={false} className="accounts-table-form-item">
                                                <Table
                                                    className="accounts-table"
                                                    dataSource={selectedAccountValues}
                                                    rowKey="id"
                                                    size="small"
                                                    pagination={{ pageSize: 5, size: "small", hideOnSinglePage: true }}
                                                    columns={[
                                                        {
                                                            title: t("pages.account-asignation.name"),
                                                            dataIndex: "name",
                                                            key: "name",
                                                            ellipsis: true,
                                                            filterSearch: true,
                                                            filters: selectedAccountValues?.map(a => ({ text: a.name, value: a.name })) ?? [],
                                                            onFilter: (value, record) => record.name.toLowerCase().includes((value as string).toLowerCase()),
                                                            render: (_: any, record: any) => (
                                                                <div style={{ display: "flex", alignItems: "flex-start", gap: "6px" }}>
                                                                    <Tooltip title={t(`components.accounts.list.account-type-${record.accountType}`)}>
                                                                        <span style={{ marginTop: "2px", flexShrink: 0 }}>
                                                                            {getAccountTypeIcon(record.accountType, "14")}
                                                                        </span>
                                                                    </Tooltip>
                                                                    <div style={{ minWidth: 0 }}>
                                                                        <div
                                                                            style={{ fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "pointer", color: "var(--primary-app-color)", textDecoration: "underline" }}
                                                                            onClick={() => navigate(`/${GetAppLanguage()}/private/accounts-admin?name=${encodeURIComponent(record.name)}`)}
                                                                        >
                                                                            {toTitleCase(record.name)}
                                                                        </div>
                                                                        {record.address && (
                                                                            <div style={{ fontSize: "11px", color: "#555", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{record.address}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            title: t("pages.account-asignation.market"),
                                                            dataIndex: "country",
                                                            key: "country",
                                                            width: 180,
                                                            ellipsis: true,
                                                            render: (code: string) => props.markets.find(m => m.key === code)?.value ?? code,
                                                        },
                                                        {
                                                            key: "actions",
                                                            width: 40,
                                                            render: (_: any, record: any) => (
                                                                <Button
                                                                    type="text"
                                                                    danger
                                                                    size="small"
                                                                    icon={<DeleteOutlined />}
                                                                    onClick={() => handleRemoveAccount(record.id)}
                                                                />
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            </Form.Item>
                                        )}
                                    </Col>
                                </>
                            )}
                        </Row>

                        <Divider style={{ margin: '12px 0' }} />

                        {/* Row 3: Botones */}
                        <div className="buttons-container">
                            {props.configuration.isDefault ? (
                                <Tooltip title={selectedPaymentIds.length === 0 ? t("pages.payments-configuration.payment-methods-required") : undefined}>
                                    <Button type="primary" loading={saving} disabled={deleting || saving || !isDirty || selectedPaymentIds.length === 0} htmlType="submit" className="app-button">
                                        {t("button.save")}
                                    </Button>
                                </Tooltip>
                            ) : (
                                <>
                                    <Tooltip title={
                                        selectedPaymentIds.length === 0
                                            ? t("pages.payments-configuration.payment-methods-required")
                                            : ((!selectedCountries || selectedCountries.length === 0) &&
                                               (!selectedAccountValues || selectedAccountValues.length === 0))
                                            ? t("pages.payments-configuration.no-accounts-or-countries")
                                            : undefined
                                    }>
                                        <Button type="primary"
                                            loading={saving}
                                            disabled={deleting || saving || !isDirty ||
                                                selectedPaymentIds.length === 0 ||
                                                ((!selectedCountries || selectedCountries.length === 0) &&
                                                (!selectedAccountValues || selectedAccountValues.length === 0))}
                                            htmlType="submit"
                                            className="app-button">
                                            {t("button.save")}
                                        </Button>
                                    </Tooltip>
                                    <Button
                                        type="default"
                                        className="app-button danger"
                                        disabled={deleting || saving}
                                        loading={deleting}
                                        onClick={() => setDeleteModalVisible(true)}>
                                        {t("button.delete")}
                                    </Button>
                                </>
                            )}
                        </div>
                    </Form>
                </Col>
            </Row>

            <GenericModal
                title={t("pages.account-asignation.confirm-delete-title")}
                closable
                content={<div>{t("pages.account-asignation.delete-message")}</div>}
                visible={deleteModalVisible}
                onOk={() => onDeleteConfiguration(props.configuration.id)}
                isLoading={deleting}
                //  setModalVisible={setDeleteModalVisible}
                onCancel={() => setDeleteModalVisible(false)}
            />
        </div >
    );
}

export default PaymentMethodElement;